import React from 'react';
import { cn } from '../../utils/cn';
import catLoadingGif from '../../assets/cat-loading.gif';

interface CatLoadingProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg';
}

const sizes = {
  sm: 'w-16 h-16',
  md: 'w-24 h-24',
  lg: 'w-32 h-32',
};

export const CatLoading: React.FC<CatLoadingProps> = ({ className, size = 'md' }) => {
  return (
    <div className={cn('flex items-center justify-center', className)}>
      <img
        src={catLoadingGif}
        alt="Loading..."
        className={cn(
          sizes[size],
          'object-contain',
          // Dark mode: invert colors with hue rotation
          'dark:invert dark:hue-rotate-180 dark:brightness-90 dark:contrast-110'
        )}
      />
    </div>
  );
};

export const CatLoadingPage: React.FC<{ className?: string }> = ({ className }) => {
  return (
    <div className={cn('flex flex-col items-center justify-center py-20 lg:py-32', className)}>
      <img
        src={catLoadingGif}
        alt="Loading..."
        className={cn(
          'w-32 h-32 sm:w-40 sm:h-40 object-contain',
          // Dark mode: invert colors with hue rotation
          'dark:invert dark:hue-rotate-180 dark:brightness-90 dark:contrast-110',
          'mb-4'
        )}
      />
      <p className="text-base-400 dark:text-base-500 text-body-sm animate-pulse">Loading...</p>
    </div>
  );
};
